module.exports = __webpack_public_path__ + "img/wximg1.bff927bc.png";